import PositionInformationFormFields from './PositionInformationFormFields.component';

export default PositionInformationFormFields;
